/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_Summary_TripsInputs */

const vi_station_work_summary_trips = /** @type {(inputs: Station_Work_Summary_TripsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đang công tác`)
};

/**

* @param {Station_Work_Summary_TripsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_summary_trips = /** @type {((inputs?: Station_Work_Summary_TripsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Summary_TripsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_summary_trips(inputs)
});